import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import storage from '@/xstorage/index'

const routes = [
  {
    path: '/authentication/login',
    component: () => import('@/pages/authentication/Login') ,
    meta: {
      private_route: false
    }
  },
  // {
  //   path: '/authentication/register',
  //   component: () => import('@/pages/authentication/Register.vue') ,
  //   meta: {
  //     private_route: false
  //   }
  // },
  // {
  //   path: '/authentication/recover-password',
  //   component: () => import('@/pages/Authentication/RecoverPassword.vue') ,
  //   meta: { private_route: false }
  // },
  // {
  //   path: '/authentication/reset-password',
  //   component: () => import('@/pages/Authentication/ResetPassword.vue') ,
  //   meta: { private_route: false }
  // },
  // {
  //   path: '/authentication/insufficient-privileges',
  //   component: () => import('@/pages/Authentication/InsufficientPrivileges.vue') ,
  //   meta: { private_route: false }
  // },
  {
    path: '/',
    redirect: '/hotels'
  },
  {
    path: '/hotels',
    component: () => import('@/pages/application/Hotel/HotelsPage'),
    meta: {
      private_route: true
    }
  },
  {
    path: '/hotel-groups',
    component: () => import('@/pages/application/HotelGroups/HotelGroupsPage'),
    meta: {
      private_route: true
    }
  },
  {
    path: '/hotel-groups/:group',
    component: () => import('@/pages/application/HotelGroups/HotelGroupPage'),
    meta: {
      private_route: true
    }
  },
  {
    path: '/orders',
    component: () => import('@/pages/application/Order/OrdersPage'),
    meta: {
      private_route: true,
      redirect: '/orders',
    }
  },
  {
    path: '/orders/:order',
    component: () => import('@/pages/application/Order/OrderPage'),
    meta: {
      private_route: true,
      redirect: '/orders',
    }
  },
  {
    path: '/suppliers',
    component: () => import('@/pages/application/Supplier/SuppliersPage'),
    meta: {
      private_route: true,
      redirect: '/suppliers',
    }
  },
  {
    path: '/suppliers/:supplier',
    component: () => import('@/pages/application/Supplier/SupplierPage'),
    meta: {
      private_route: true,
      redirect: '/suppliers',
    }
  },
  {
    path: '/invoices',
    component: () => import('@/pages/application/Invoice/InvoicesPage'),
    meta: {
      private_route: true,
      redirect: '/invoices',
    }
  },
  {
    path: '/invoices/:invoice',
    component: () => import('@/pages/application/Invoice/InvoicePage'),
    meta: {
      private_route: true,
      redirect: '/invoices',
    }
  },
  {
    path: '/transactions',
    component: () => import('@/pages/application/Transaction/TransactionsPage'),
    meta: {
      private_route: true,
      redirect: '/transactions',
    }
  },
  {
    path: '/transactions/:transaction',
    component: () => import('@/pages/application/Transaction/TransactionPage'),
    meta: {
      private_route: true,
      redirect: '/transactions',
    }
  },
  {
    path: '/hotels/:hotel',
    component: () => import('@/pages/application/Hotel/HotelPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel'
    }
  },
  {
    path: '/hotels/:hotel/rooms',
    component: () => import('@/pages/application/Room/RoomsPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/rooms'
    }
  },
  {
    path: '/hotels/:hotel/rooms/:room',
    component: () => import('@/pages/application/Room/RoomPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/rooms'
    }
  },
  {
    path: '/hotels/:hotel/rates',
    component: () => import('@/pages/application/Rate/RatesPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/rates'
    }
  },
  {
    path: '/hotels/:hotel/rates/:rate',
    component: () => import('@/pages/application/Rate/RatePage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/rates'
    }
  },
  {
    path: '/hotels/:hotel/cancellation-policies',
    component: () => import('@/pages/application/PolicyCancellation/PoliciesPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/cancellation-policies'
    }
  },
  {
    path: '/hotels/:hotel/cancellation-policies/:policy',
    component: () => import('@/pages/application/PolicyCancellation/PolicyPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/cancellation-policies'
    }
  },
  {
    path: '/hotels/:hotel/payment-policies',
    component: () => import('@/pages/application/PolicyPayment/PoliciesPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/payment-policies'
    }
  },
  {
    path: '/hotels/:hotel/payment-policies/:policy',
    component: () => import('@/pages/application/PolicyPayment/PolicyPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/payment-policies'
    }
  },
  {
    path: '/hotels/:hotel/contracts',
    component: () => import('@/pages/application/Contract/ContractsPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/contracts'
    }
  },
  {
    path: '/hotels/:hotel/contracts/:contract',
    component: () => import('@/pages/application/Contract/ContractPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/contracts'
    }
  },
  {
    path: '/hotels/:hotel/sheet',
    component: () => import('@/pages/application/Sheet/SheetPage'),
    meta: {
      private_route: true,
      redirect: '/hotels/:hotel/sheet',
    }
  },
  {
    path: '/admin/users',
    component: () => import('@/pages/application/Admin/UsersPage'),
    meta: {
      private_route: true,
      redirect: '/admin/users',
    }
  },
  {
    path: '/admin/users/:user',
    component: () => import('@/pages/application/Admin/UserPage'),
    meta: {
      private_route: true,
      redirect: '/admin/users',
    }
  },
  {
    path: '/admin/roles',
    component: () => import('@/pages/application/Admin/RolesPage'),
    meta: {
      private_route: true,
      redirect: '/admin/roles',
    }
  },
  {
    path: '/admin/roles/:role',
    component: () => import('@/pages/application/Admin/RolePage'),
    meta: {
      private_route: true,
      redirect: '/admin/roles',
    }
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

router.beforeEach(async (to, from, next) => {

  let token = await storage.getToken();
  let roles = await storage.getRoles();

  if (!token && to.meta.private_route) {
    return next('/authentication/login');
  }

  return next();

});

export default router
